<template>
    <div class="donation-detail">
      <van-nav-bar
        title="捐款成功"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
      />
        <div class="detail-center">
          <img src="@/assets/donation_success_image.png" alt="">
          <div class="donation_success">捐款成功</div>
          <div class="donation_think">感谢您的爱心</div>
        </div>
      <div class="school_logo"><img src="@/assets/form_logo.png" alt=""></div>
    </div>
</template>

<script>
export default {
  name: 'donation-detail',
  data () {
    return {
      money: ''
    }
  },
  created () {
    this.money = this.$route.query.money
  },
  methods: {
    onClickLeft () {
      this.$router.push('/map')
    }
  }
}
</script>

<style scoped lang="less">
    .donation-detail {
      .detail-center{
        width: 100%;
        padding-top: 142px;
        text-align: center;
        img{
          width: 120px;
          height: 120px;
        }
        .donation_success{
          margin: 24px 0 14px;
          font-size: 28px;
          color: rgba(8,14,35,0.8);
        }
        .donation_think{
          font-size: 16px;
          color: #7D7D7D;
        }
      }
      .school_logo{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 40px;
        width: 100%;
        height: 33px;
        text-align: center;
        img{
          width: 234px;
          height: 100%;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/donation/detail.vue